module.exports = __webpack_public_path__ + "img/dowrzh.4efdde5.png";